import React, { useEffect, useState } from "react";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, name:props.gadget };
    }

    static getDerivedStateFromError(error) {
        // 다음 렌더링에서 폴백 UI가 보이도록 상태를 업데이트 합니다.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // 에러 리포팅 서비스에 에러를 기록할 수도 있습니다.
        console.log(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <h3>{this.state.name}에 문제가 있습니다.</h3>;
        }

        return this.props.children;
    }
}